interface StatefulOverviewData {
    view?: "table" | "tiles";
}

const getStorageKey = (scope: string): string =>
    `trumpf.ux.iws.statefulContent.overview.${scope}`;

export const getStatefulOverviewStyle = (
    scope: string
): StatefulOverviewData => {
    const item = sessionStorage.getItem(getStorageKey(scope));
    if (item === null) {
        return {};
    }
    try {
        return JSON.parse(item);
    } catch {
        return {};
    }
};

export const setStatefulOverviewStyle = (
    scope: string,
    data: Partial<StatefulOverviewData>
): void => {
    const existingData = getStatefulOverviewStyle(scope);
    const updatedData = { ...existingData, ...data };
    sessionStorage.setItem(getStorageKey(scope), JSON.stringify(updatedData));
};
